<template>
  <AuthForm
      class="login-page__form"
      :model="form"
      :rules="rules"
      layout="vertical"
      @submit.prevent="handleSubmit"
  >
    <a-form-item
        :label="t('ui.email-input-label')"
        name="email"
        :validate-status="validateStatus"
    >
      <a-input
          v-model:value="form.email"
          placeholder="email@email.com"
          size="large"
          @update:value="handleInputChange"
      />
    </a-form-item>

    <template #actions>
      <a-button
          class="login-page__form-button full-width"
          type="primary"
          html-type="submit"
          :loading="loading"
          :disabled="!isFormValid"
      >
        {{ t('ui.get-code-button-label') }}
      </a-button>
    </template>
  </AuthForm>
</template>

<script setup lang="ts">
import {  computed, reactive } from 'vue'
import { AuthForm } from '@/ui/common/auth'
import type { Rule } from 'ant-design-vue/es/form'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
  loading: boolean
  hasError: boolean
}>()

const emit = defineEmits<{
  (e: 'submit', email: string): void
  (e: 'sign-up'): void
}>()

const form = reactive({
  email: '',
})

const rules = computed<Record<string, Rule[]>>(() => ({
  email: [{ required: true, type: 'email', message: t('rules.email-required-text') }],
}))

const validateStatus = computed(() => {
  if (props.hasError) return 'error'
  return undefined
})

const isFormValid = computed(() => {
  return form.email.trim() !== ''
})

const handleInputChange = () => {
  if (props.hasError) {
  }
}

const handleSubmit = () => {
  emit('submit', form.email)
}
</script>

<style lang="scss" scoped>
.login-page {
  &__form {
    &-button {
      width: 100%;
      margin-bottom: 8px;
    }
  }
}
</style>